"use client";

import Link from "next/link";
import dynamic from "next/dynamic";
const MobileSidebar = dynamic(() => import("../../mobile/MobileSidebar"), { ssr: false });
const SettingsModal = dynamic(() => import("../../SettingsModal"), { ssr: false });
import {
  FiArrowLeft,
  FiCalendar,
  FiHeart,
  FiMenu,
  FiSearch,
  FiShoppingCart,
  FiX,
} from "react-icons/fi";

import Image from "next/image";
import { useHeader } from "@/hooks/customer/useHeader";

const BlogHeader = () => {
  const {
    router,
    isAuthenticated,
    isSettingsOpen,
    setIsSettingsOpen,
    profileRef,
    profileSummary,
    isScrolled,
    isMobileNavOpen,
    setIsMobileNavOpen,
    totalQuantity,
    wishlistCount,
    isSearchOpen,
    setIsSearchOpen,
    query,
    setQuery,
    suggestions,
    isReviewPage,
    handleSelection,
    isHomePage,
  } = useHeader();

  return (
    <>
      {/* Top Navigation - Copied from HeroSectionMobile */}
      <nav
        className={`lg:hidden fixed left-2 right-2 z-[100] flex items-center justify-between px-2 py-2 border border-white rounded-xl text-white ${
          isScrolled
            ? "bg-white/30 backdrop-blur-md top-0"
            : "bg-[#D9D9D933] backdrop-blur-sm top-2"
        }`}
      >
        {/* Left side - Menu button */}
        <div className="flex items-center gap-2">
          <button
            type="button"
            aria-label="Toggle menu"
            onClick={() => setIsMobileNavOpen((v) => !v)}
            className="rounded-lg p-1 transition-colors hover:bg-white/10 text-black cursor-pointer"
          >
            {isMobileNavOpen ? (
              <FiX className="h-6 w-6" />
            ) : (
              <FiMenu className="h-6 w-6" />
            )}
          </button>

          {!isSearchOpen && (
            <Link href="/" className="flex items-center">
              <div className="relative h-8 aspect-3/1">
                <Image
                  src="/images/logo1.png"
                  alt="TripsAdora Logo"
                  fill
                  sizes="190px"
                  className="object-contain"
                   
                />
              </div>
            </Link>
          )}
        </div>

        {/* Right side - Icons */}

        {/* 2. Expandable Search Input */}
        <div
          className={`flex items-center transition-all duration-300 ${isSearchOpen ? "w-full" : "w-auto"}`}
        >
          {!isHomePage && (
            <div className="flex items-center w-full relative overflow-hidden">
              {/* Search Bar — right se slide aata hai */}
              <div
                className={`flex items-center w-full bg-gray-100 rounded-full border border-black px-3 py-1 mx-3 transition-all duration-1000 ease-in-out ${
                  isSearchOpen
                    ? "translate-x-0 opacity-100"
                    : "translate-x-full opacity-0 pointer-events-none absolute"
                } ${"border-black/20 focus-within:border-black focus-within:ring-1 focus-within:ring-black"}`}
              >
                <FiArrowLeft
                  className="text-gray-500 cursor-pointer"
                  onClick={() => setIsSearchOpen(false)}
                />
                <input
                  autoFocus={isSearchOpen}
                  className="bg-transparent text-black border-none outline-none w-full px-2 text-sm h-5"
                  placeholder={
                    isReviewPage
                      ? "Search your bookings..."
                      : "Search tours & blogs..."
                  }
                  value={query}
                  onChange={(e) => setQuery(e.target.value)}
                />
                {query && (
                  <FiX
                    className="text-gray-400 cursor-pointer"
                    onClick={() => setQuery("")}
                  />
                )}
              </div>

              {/* Search Icon — fade out hota hai */}
              <div
                className={`flex items-center transition-all duration-500 ease-in-out ${
                  isSearchOpen
                    ? "opacity-0 pointer-events-none absolute"
                    : "opacity-100"
                }`}
              >
                <button
                  onClick={() => setIsSearchOpen(true)}
                  aria-label="Search"
                  className="p-1 text-black bg-[#FFEDB8] rounded-full cursor-pointer"
                >
                  <FiSearch className="h-5 w-5" />
                </button>
              </div>
            </div>
          )}

          {/* Right Icons: Compare, Wishlist, Cart, Bookings */}
          <div className="flex items-center gap-1 shrink-0">
       
          <button
            onClick={() => router.push("/comparison")}
            aria-label="Compare"
            className="rounded-lg cursor-pointer p-1 transition-colors hover:bg-white/10 text-black flex items-center justify-center relative"
          >
            <Image
              src="/images/compare.png"
              alt="Compare"
              width={30}
              height={30}
              className="w-5 h-5 object-contain"
            />
          </button>
          <button
            onClick={() => router.push("/wishlist")}
            aria-label="Wishlist"
            className="rounded-lg cursor-pointer p-1 transition-colors hover:bg-white/10 text-black relative"
          >
            <FiHeart className="h-5 w-5" />
            {wishlistCount > 0 && (
              <span className="absolute -top-1 -right-1 bg-red-500 text-white span-text font-bold w-4.5 h-4.5 rounded-full flex items-center justify-center">
                {wishlistCount}
              </span>
            )}
          </button>
          <button
            onClick={() => router.push("/cart")}
            aria-label="Cart"
            className="rounded-lg cursor-pointer p-1 transition-colors hover:bg-white/10 text-black relative"
          >
            <FiShoppingCart className="h-5 w-5" />
            {totalQuantity > 0 && (
              <span className="absolute -top-1 -right-1 bg-red-500 text-white span-text font-bold w-4.5 h-4.5 rounded-full min-w-[18px] flex items-center justify-center">
                {totalQuantity}
              </span>
            )}
          </button>
          <button
            onClick={() => router.push("/my-bookings")}
            aria-label="Bookings"
            className="rounded-lg p-1 cursor-pointer transition-colors hover:bg-white/10 text-black"
          >
            <FiCalendar className="h-5 w-5" />
          </button>
   </div>

        </div>
        {/* 3. Suggestions Dropdown */}
        {isSearchOpen && query && (
          <div className="absolute top-full left-0 w-full bg-white shadow-xl z-[100] max-h-[80vh] overflow-y-auto">
            {suggestions.map((item) => (
              <div
                key={item.id}
                onClick={() => handleSelection(item)}
                className="flex items-center gap-3 p-3 border-b border-gray-50 active:bg-gray-100"
              >
                <Image
                  src={item.image || "/placeholder.jpg"}
                  alt="image"
                  width={40}
                  height={40}
                  className="w-10 h-10 rounded object-cover"
                   
                />
                <div className="flex-1">
                  <p className="text-sm font-medium text-black">{item.title}</p>
                  <p className="text-[10px] text-gray-400 uppercase">
                    {item.type}
                  </p>
                </div>
              </div>
            ))}
          </div>
        )}
      </nav>

      {/* Mobile Sidebar */}
      <MobileSidebar
        isOpen={isMobileNavOpen}
        onClose={() => setIsMobileNavOpen(false)}
        isAuthenticated={isAuthenticated}
        onProfileClick={() => setIsSettingsOpen(true)}
        onLoginClick={() => router.push("/login")}
      />

      <SettingsModal
        isOpen={isSettingsOpen}
        onClose={() => setIsSettingsOpen(false)}
        profileRef={profileRef}
        profile={profileSummary}
      />
    </>
  );
};

export default BlogHeader;
